import { render, staticRenderFns } from "./ProductWeight4.vue?vue&type=template&id=c1721ad8&scoped=true"
import script from "./ProductWeight4.vue?vue&type=script&lang=js"
export * from "./ProductWeight4.vue?vue&type=script&lang=js"
import style0 from "./ProductWeight4.vue?vue&type=style&index=0&id=c1721ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1721ad8",
  null
  
)

export default component.exports